import AppPageEmpty from '@/components/app-page/index-empty.vue';

export default [{
  path: '/link-manage',
  name: 'LinkManage',
  component: AppPageEmpty,
  meta: {
    title: '链路管理',
    style: 'link',
  },
  children: [
    {
      path: 'list',
      name: 'LinkList',
      component: () => import('@/views/link-manage/list/index.vue'),
      meta: {
        title: '事件链路',
        activeMenu: '/link-manage/list',
        isUseAppInfo: true,
        style: 'link',
      },
    },
    {
      path: 'link',
      name: 'LinkEdit',
      component: () => import('@/views/link-manage/link/index.vue'),
      meta: {
        title: '事件链路编辑',
        activeMenu: '/link-manage/list',
        isUseAppInfo: true,
        isNotMenu: true,
      },
    },
    {
      path: 'analysis',
      name: 'LinkaAnalysis',
      component: () => import('@/views/link-manage/analysis/index.vue'),
      meta: {
        title: '事件链路分析',
        activeMenu: '/link-manage/analysis',
        isUseAppInfo: true,
        isNotMenu: true,
      },
    },
  ],
}];
